export const dataRegionMap = {
  WEU: "Western Europe",
  EUS: "United States",
  UAE: "UAE",
} as Record<string, string>
